import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import ManageStudents from "../../teacher_pages/components/ManageStudents";
import TeacherRequestSelect from "../components/TeacherRequestSelect";

function TeacherRequestSelectCommonPage() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "teacher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);
    

    return (
        <div className={`min-h-screen overflow-y-auto overflow-x-hidden ${i18n.language==="en"?"font-urban":(i18n.language==="si"?"font-noto":"font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                <p className="ml-[10px] mr-[100px]  font-semibold text-[15px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala"?"සිංහල":(language === "Tamil"?"தமிழ்":language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-b.svg" alt="home" onClick={() => navigate('/desktop/teacher/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/teacher/mailbox')
                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/teacher/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala"?"සිංහල":(language === "Tamil"?"தமிழ்":language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <TeacherRequestSelect />

            <div className="xl:hidden grid grid-cols-4 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" onClick={() => navigate('/mobile/teacher/dashboard')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" alt="mail" onClick={() => navigate('/mobile/teacher/mailbox/inbox')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" alt="person" onClick={() => navigate('/mobile/teacher/profile')} /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" alt="settings" onClick={() => navigate('/mobile/teacher/settings')} /></div>
            </div>
        </div>
    )
}

export default TeacherRequestSelectCommonPage;